import { IApplicationState } from '../../types/redux';

export function getIsAeroPhotoTourOpen(state: IApplicationState) {
  return state.aeroPhotoTour.isModalOpen;
}
